import { useEffect, useState, useRef } from "react";

export const useWebsocket = (
  socketData: { socketUrl?: any; },
  isValid: boolean,
  onMessage: (val: any) => void ) => {
  
  const {socketUrl} = socketData;
  let clientRef = useRef<any>(null);
  const [waitingToReconnect, setWaitingToReconnect] = useState(null);

  useEffect(() => {
    if (waitingToReconnect || !isValid) return;

    if (!clientRef.current) {
      const client = new WebSocket(socketUrl);
      clientRef.current = client;
      // @ts-ignore
      window.client = client;

      client.onopen = () => {
        console.log("ws opened");
      };

      client.onmessage = function (event) {
        console.log("ws message sent by the server");
        onMessage(event.data);
      };

      client.onerror = (error) => {
        console.log("ws error", error);
      };

      client.onclose = () => {
        if (clientRef.current) {
          // Connection failed
          console.log("ws closed by server");
        } else {
          // Cleanup initiated from app side, can return here, to not attempt a reconnect
          console.log("ws closed by app component unmount");
          return;
        }

        if (waitingToReconnect) {
          return;
        }
        
        // @ts-ignore
        setWaitingToReconnect(true);

        // This will trigger another re-run, and because it is false,
        // the socket will be set up again
        setTimeout(() => setWaitingToReconnect(null), 5000);
        clientRef.current = null;

        return () => {
          console.log("Cleanup");
          clientRef.current = null;

          client.close();
        };
      };
    }
  }, [waitingToReconnect, socketUrl]);
};
